let normal = {
    'v_index_PocketCash': '现金贷',
    'v_index_homepage': '主页',
    'v_index_Product_introduction': '产品介绍',
    'v_index_About_us': '关于我们',
    'v_index_con1_tit1': '多种取款方式',
    'v_index_con1_tit2': '仅需APP申请',
    'v_index_con1_tit3': '兴趣偏好',
    'v_index_con1_txt1': '最快30分钟到账',
    'v_index_con1_txt2': '操作简单，审核快',
    'v_index_con1_txt3': '比同类产品低36％',
    'v_index_con2_tit': '轻松三步',
    'v_index_con2_titdetail': '最快30分钟到达',
    'v_index_con2_con1': '登录注册',
    'v_index_con2_con21': '填写信息',
    'v_index_con2_con22': '等待审核',
    'v_index_con2_con31': '申请贷款',
    'v_index_con2_con32': '等待到账',
    'v_index_con2_con4': '审核通过',
    'v_index_con3_tit1': '仅需提供四项资料',
    'v_index_con3_tit2': '独创智能风控技术，为所有人提供消费金融服务',
    'v_index_con3_tit3': '有领先全球的金融科技服务',
    'v_index_con3_tit4': '真实的信贷借贷',
    'v_index_con3_con11': '审核快速，通过率高',
    'v_index_con3_con12': '让更多用户享受信用贷款服务',
    'v_index_con3_con21': '提供消费者金融服务',
    'v_index_con3_con31': '7 * 24H贷款',
    'v_index_con3_con32': '1秒内即可完成资金匹配',
    'v_index_con3_con33': '最快30分钟到账',
    'v_index_con3_con41': '真正的信用贷款，无需任何抵押',
    'v_index_con3_con42': '在APP内完成全部申请操作',
    'v_index_con4_tit': '现金贷是一家拥有丰富经验的高科技互联网金融公司。',
    'v_index_con4_con': '一方面通过移动互联网和独创的智能风控技术为用户提供信用评估，一方面对接金融机构，使所有人都可以享受到消费金融服务。',
    'v_index_foot1': 'XXX P2P IT CO.LTD',
    'v_index_foot2': 'Company: Elending Lending Inc',
    'v_index_con0_detail1': '提供多种信贷服务',
    'v_index_con0_detail2': '轻松借钱',
    'v_index_language': '语言',
    'v_index_download': '下载',
    'v_index_downloaddetails': '扫描二维码，下载PocketCash。',
}
export default normal


// WEBPACK FOOTER //
// ./src/language/config/zh-CN.js